module.exports = __webpack_public_path__ + "static/media/furnitures.889a1f5f.svg";